type GetShortcutKeyParams = {
    isMacOs: boolean;
    isWindows: boolean;
    locale?: string;
    /** The letter the modifier is combined with. */
    letter?: string;
};

export function getShortcutKey({ isMacOs, isWindows, locale, letter = 'K' }: GetShortcutKeyParams): string {
    if (isMacOs) {
        return `⌘ ${letter}`;
    }

    const isGermanLocale = locale?.toLowerCase().startsWith('de') ?? false;

    if (isWindows && isGermanLocale) {
        return `Strg ${letter}`;
    }

    return `Ctrl ${letter}`;
}
